import React from 'react';
import { impactLevels } from '../../utils/constants';

function ImpactDropdown({ value, onChange, name, id }) {
  return (
    <select
      id={id}
      name={name}
      value={value || 'None'}
      onChange={onChange}
      className="w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-blue-500"
    >
      {impactLevels.map((level) => (
        <option key={level.value} value={level.value}>
          {level.label}
        </option>
      ))}
    </select>
  );
}

export default ImpactDropdown;
